const ITEMS = [
    "Higienização Profissional",
    "Limpeza de Estofados",
    "Higienização de Sofás",
    "Higienização de Colchões",
    "Higienização de Tapetes",
    "Higienização Automotiva",
    "Impermeabilização",
];

export const Marquee = () => {
    const content = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="services-marquee"
            className="relative bg-brand py-6 overflow-hidden border-y border-navy/20"
            aria-hidden="true"
        >
            <div className="marquee-track flex items-center gap-14 whitespace-nowrap w-max">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center gap-14">
                        {content.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center gap-14">
                                <span className="font-display font-bold text-2xl sm:text-3xl text-white tracking-tight">
                                    {item}
                                </span>
                                <span className="text-navy text-xl">◆</span>
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};
